import { render, staticRenderFns } from "./RoleCan.vue?vue&type=template&id=c4f0abfa&"
import script from "./RoleCan.vue?vue&type=script&lang=ts&"
export * from "./RoleCan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports